import React from 'react';
import { BarMenuIcons, SearchIcons } from '../../../../../icons/icons';
import { NameEmailAvatar } from '../../../../../ui';
import { Applicant } from '../../../../../utils/types/JobOpenings';
interface ISeachResults{
    setShowSearchPanel: (show: boolean) => void;
    filteredCandidates: Applicant[];
    getApplicantInitials: (candidate: any) => string;
    handleViewApplicantProfile: (candidate: any) => void;
}
export const SearchResults = (props : ISeachResults) => {
  const { setShowSearchPanel,filteredCandidates,getApplicantInitials,handleViewApplicantProfile } = props;
  return (
    <div className='w-80 bg-white/95 backdrop-blur-sm border-l border-gray-100 shadow-md h-fit'>
      <div className='p-6 border-b border-gray-100 bg-gradient-to-r from-emerald-50 to-blue-50'>
        <div className='flex justify-between items-center'>
          <h3 className='text-lg font-semibold text-gray-900 flex items-center gap-2'>
            <SearchIcons className='w-5 h-5 text-emerald-600' />
            Search Results
          </h3>
          <button
              onClick={() => setShowSearchPanel(false)}
              className='p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-white/50 transition-all duration-200'
          >
            <BarMenuIcons className='w-5 h-5' />
          </button>
        </div>
        <p className='text-sm text-gray-600 mt-2 font-medium'>
          { filteredCandidates.length } candidate
          { filteredCandidates.length !== 1 ? 's' : '' } found
        </p>
      </div>

      <div className='max-h-96 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent'>
        { filteredCandidates.map((candidate, index) => {
          const fullName =
               candidate.name || `${candidate.firstName} ${candidate.lastName}`;
          const initials = getApplicantInitials(candidate);

          return (
            <div
                key={candidate.userId}
                onClick={() => handleViewApplicantProfile(candidate)}
                className='p-4 border-b border-gray-50 hover:bg-gradient-to-r hover:from-emerald-50 hover:to-blue-50 cursor-pointer transition-all duration-300 hover:shadow-sm'
            >
              <div className='flex items-center space-x-3'>
                { /* Avatar */ }
                <NameEmailAvatar
                    applicantStatus={candidate.applicantStatus}
                    avatar={candidate.lastName || undefined}
                    name={fullName}
                    email={candidate.email}
                />
              </div>
            </div>
          );
        }) }
      </div>
    </div>
  );
};
